import React, { useCallback } from 'react';

import styled, { css } from 'styled-components';

import EditOutlined from '@mui/icons-material/EditOutlined';

import { Box, Typography } from 'components';
import { useTranslation } from 'react-i18next';

const StyledEditIcon = styled(EditOutlined)<{ disabled?: boolean }>`
  color: ${props =>
    props.disabled
      ? props.theme.custom.palette.muted700
      : props.theme.custom.palette.secondary700};
  width: 1.8rem;
  height: 1.8rem;
`;

export const EditLabel = styled(Typography)<{ disabled?: boolean }>`
  display: inline-block;
  color: ${props =>
    props.disabled
      ? props.theme.custom.palette.muted700
      : props.theme.custom.palette.secondary700};
  padding-left: 0.6rem;
  font-weight: 900;
  font-size: 12px;
  text-transform: uppercase;
  text-decoration: underline;
`;

const StyledEditWrapper = styled(Box)<{ disabled?: boolean }>`
  display: flex;
  cursor: 'pointer';
  align-items: center;
  justify-content: center;
  opacity: ${props => (props.disabled ? 0.6 : 1)};

  ${props =>
    !props.disabled &&
    css`
      &:hover ${StyledEditIcon}, &:hover ${EditLabel} {
        color: ${props.theme.custom.palette.primary500};
      }
    `}
`;

type Props = {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
};

export const EditButton: React.FC<Props> = ({
  onClick,
  className,
  disabled,
}) => {
  const { t } = useTranslation();

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (disabled) {
        event.stopPropagation();
        return;
      }
      if (onClick) {
        onClick();
      }
    },
    [disabled, onClick],
  );

  return (
    <StyledEditWrapper
      className={className}
      flexDirection={'row'}
      onClick={handleClick}
      disabled={disabled}
    >
      <StyledEditIcon disabled={disabled} />
      <EditLabel variant="body2" disabled={disabled}>
        {t('common.edit')}
      </EditLabel>
    </StyledEditWrapper>
  );
};
